import React, { useState, useEffect } from "react";
import { Form, Button,Modal,InputNumber} from "antd";
import { API_TXALERT2 } from "../../../config/config";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import GroupAccess from "../../../helper/GroupAccess";
import TxalertBankDropdown from "../Components/BankDropdown";
import CatchError from "../../../helper/CatchError";


const Txalert_AcquiringBankAccount = (props) => {
    const { t, id,setId,isOpen,setIsOpen, fetchList } = props;
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [componentDisabled, setComponentDisabled] = useState(GroupAccess("SYSADMIN") ? false : true); // eslint-disable-line
    
   
    const layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    };

    const initData = {
        acquiring_bank_id: "",
        bin: 0,
        mid: 0,
    };

    const handleOk = () => {
        setLoading(true);
        onFinish();
    };

   

    const [form] = Form.useForm();

    const handleCancel = () => {             
        setLoading(false);
        setId('');
        form.setFieldsValue(initData);
        setIsOpen(false);
        
    };

    const formValChange = (chgV, allV) => {        
            setDetails(allV);      
    };

    useEffect(() => {
     
        if(isOpen){
            if (typeof id != 'undefined') {
            
                getDetails();
            }else{
                setDetails(initData);
            }
        }
    }, [isOpen]); // eslint-disable-line

   
    const getDetails = async () => {

        const api_url = API_TXALERT2 + `/acquiring_bank_account/${id}`;
        await axios
            .get(api_url, { headers: { Authorization: Cookies.get("txalert_token") } })
            .then(({ data }) => {
                let recdata = data;
                setDetails(recdata);              
                form.setFieldsValue(recdata);
            })
            .catch((error) => console.log(error));
    };

    const onFinish = () => {
        let apiUrl = API_TXALERT2 ;
      
       if(id === 'undefined' || typeof id === 'undefined' || id === ''){
        apiUrl = apiUrl + "/acquiring_bank_account";
       }else{
        apiUrl = apiUrl + "/acquiring_bank_account/"+id;
       }
         axios
             .post(apiUrl, details,{ headers: { Authorization: "Bearer " + Cookies.get("txalert_token") }})
             .then(({ data }) => {
                 if (data.status === "OK") {
                     Swal.fire({
                         icon: "success",
                         title: data.msg,
                         showConfirmButton: false,
                         timer: 2000,
                         onClose: () => {
                             fetchList();
                         },
                     });
                     handleCancel();
                 } else {
                    
                     CatchError(data);
                 }
             })
             .catch((error) => {
                console.log(error.response);
                 setLoading(false);
                 CatchError(error);
             });
     };
    const isOkButtonProps = () => !details || !details.acquiring_bank_id || loading;
    return(
        <>
            <Modal
                title={id !== undefined?t("contents.txalert_admin.form.view_acquiring_bank_account")+ ' id:'+id:t("contents.txalert_admin.form.add_acquiring_bank_account")}
                visible={isOpen}
                width={600}
                onCancel={handleCancel}
                onOk={handleOk}
                bodyStyle={{ paddingTop: '0px' }}
                footer={[
                    <Button key="back" onClick={() => handleCancel()}>
                        {t("contents.txalert_admin.form.cancel")}
                    </Button>,
                     GroupAccess("SYSADMIN") ? 
                    <Button key="submit" type="primary" loading={loading} disabled={isOkButtonProps()} onClick={() => handleOk()}>
                        {loading ? t("contents.txalert_admin.form.submitting") : t("contents.txalert_admin.form.submit")}
                    </Button>:'',
                ]}
            >
                <Form {...layout} form={form} name="detail" onValuesChange={formValChange}  >
                    <fieldset disabled={componentDisabled}>
                        <Form.Item name="acquiring_bank_id" label={t("contents.txalert_admin.form.bank_name")} rules={[{ required: true }]} style={{ marginBottom: ".5rem" }} >
                            <TxalertBankDropdown />
                        </Form.Item>
                        <Form.Item name="bin" label={t("contents.txalert_admin.form.bin")} rules={[{ required: true }]}  style={{ marginBottom: ".5rem" }} >
                            <InputNumber />
                        </Form.Item>
                        <Form.Item name="mid" label={t("contents.txalert_admin.form.mid")} rules={[{ required: true }]} style={{ marginBottom: ".5rem" }} >
                            <InputNumber />
                        </Form.Item>
                        
                    </fieldset>
                </Form>
            </Modal>
 
        </>
    );
};

export default Txalert_AcquiringBankAccount;
